module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// ./~/.6.26.0@babel-runtime/regenerator/index.js
// module id = 243
// module chunks = 1